// Shared by the React fallback pages and by open-redirect.ts, which renders before React
// exists — so nothing here may import React, the router or a component.

export const GO_HOME_LABEL = "Go to home";

export const BROKEN_LINK_MESSAGE =
  "This link looks incomplete. Some mail apps shorten long links — try opening it from the original email, or ask the sender to share it again.";

// Same key ThemeProvider persists to.
export const THEME_STORAGE_KEY = "wcl-ui-theme";

// Mirrors :root and .dark in app.css. Duplicated rather than derived because the
// pre-mount page cannot read CSS variables from a stylesheet it never loads — app.css is
// ~960KB and belongs to the bundle that path deliberately skips.
export const THEME_PALETTES = {
  light: {
    bg: "oklch(1 0 0)",
    fg: "oklch(0.145 0 0)",
    muted: "oklch(0.556 0 0)",
    primary: "#1c3693",
    primaryFg: "oklch(0.985 0 0)",
  },
  dark: {
    bg: "oklch(0.145 0 0)",
    fg: "oklch(0.985 0 0)",
    muted: "oklch(0.708 0 0)",
    primary: "oklch(0.578 0.156 266.53)",
    primaryFg: "oklch(0.985 0 0)",
  },
};

export const resolveThemePalette = () => {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(THEME_STORAGE_KEY);
  } catch {
    // Blocked storage falls through to the system preference.
  }
  const dark =
    stored === "dark" ||
    (stored !== "light" &&
      !!window.matchMedia?.("(prefers-color-scheme: dark)").matches);
  return dark ? THEME_PALETTES.dark : THEME_PALETTES.light;
};
